export const FETCH_COUNTRIES = 'search/FETCH_COUNTRIES';
export const FETCH_LOCATIONS = 'search/FETCH_LOCATIONS';
export const POST_SEARCH = 'search/POST_SEARCH';
export const SET_COUNTRY = 'search/SET_COUNTRY';
export const SET_CURRENCY = 'search/SET_CURRENCY';
export const SET_DRIVER_AGE = 'search/SET_DRIVER_AGE';
export const SET_DROPOFF_DATE = 'search/SET_DROPOFF_DATE';
export const SET_DROPOFF_DIFFERENT = 'search/SET_DROPOFF_DIFFERENT';
export const SET_DROPOFF_LOCATION = 'search/SET_DROPOFF_LOCATION';
export const SET_DROPOFF_TIME = 'search/SET_DROPOFF_TIME';
export const SET_GUEST_TOKEN = 'search/SET_GUEST_TOKEN';
export const SET_PASSENGERS = 'search/SET_PASSENGERS';
export const SET_PICKUP_DATE = 'search/SET_PICKUP_DATE';
export const SET_PICKUP_LOCATION = 'search/SET_PICKUP_LOCATION';
export const SET_PICKUP_TIME = 'search/SET_PICKUP_TIME';
export const SET_PROMO_CODE = 'search/SET_PROMO_CODE';
export const SET_QUOTE_ID = 'search/SET_QUOTE_ID';
export const SET_SEARCH_STATE = 'search/SET_SEARCH_STATE';
export const SET_TRANSMISSION = 'search/SET_TRANSMISSION';
export const SET_AGENT_ID = 'search/SET_AGENT_ID';
export const SET_CORPORATE_POA = 'search/SET_CORPORATE_POA';
export const SET_CORPORATE_CREDIT = 'search/SET_CORPORATE_CREDIT';
export const CLEAR_SEARCH = 'search/CLEAR_SEARCH';



// WEBPACK FOOTER //
// ./resources/scripts/greenmotion-shared/vuex/search/mutation-types.js